
// Conteo de temporadas 
export const seasonCountFunction = (seasons) =>{
    let seasonsCount = {};
    seasons.forEach((a) => {
        seasonsCount[a.season] = true
    });
    return seasonsCount;
}

//Sort content in ascending order by seasons
export const seasonsSort = (seasonCount, content) => {
    const contentCopy = [...content];
    return (!Array.isArray(contentCopy) || contentCopy.length === 0) ? 1
           :
           seasonCount == 1 ? contentCopy?.shift().season : contentCopy?.sort((a, b) =>  { return a?.season - b?.season }).shift().season; 
}

//Seasons Counter
export const seasonsCounter = (seasonCount) => {

    return Object.keys(seasonCount).length; 
}

//Get last episode id by last season
export const getLastEpisodeIdByLastSeason = (content) => {
    const lastSeason = content?.episodesBySeason?.pop();
    const lastEpisodeId = lastSeason?.episodes?.pop();
    
    return lastEpisodeId; 
}

//Get First episode acitve id
export const getFirstEpisodeActive = (content) => {
    const contentCopy = [...content];

    return contentCopy?.sort((a, b) =>  { return a?.season - b?.season })[0].episodes[0]; 
}
